module.exports = __webpack_public_path__ + "img/glitter_13.8317ee3a.jpg";